import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import client, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, loadPrefs } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const run = async () => {
      try {
        const { data } = await client.post("/auth/google/session", { session_id: sid });
        window.history.replaceState({}, document.title, window.location.pathname);
        setToken(data.session_token);
        setUser(data.user);
        loadPrefs();
        navigate(data.user.onboarded ? "/" : "/onboarding", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    if (sid) run(); else navigate("/login", { replace: true });
  }, [navigate, setUser, loadPrefs]);

  return (
    <div className="min-h-screen grid place-items-center bg-pp-cream">
      <div className="pp-pop flex flex-col items-center gap-3">
        <img src="/pantry-pilot-logo.png" alt="" className="h-14 w-14 rounded-2xl animate-pulse" />
        <p className="text-pp-muted text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
